import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H1 } from 'foundations-components/transitional/components/H1';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogHeaderImage } from 'foundations-components/transitional/components/DialogHeaderImage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProgressTransferVerifiedModal = ({
  error,
  onConfirm,
  progressTransferVerified,
  trackEvent,
  ErrorComponent
}) => {
  const renderSimpleModalWrapper = children => {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(DialogHeader, {}), /*#__PURE__*/_jsx(DialogFooter, {
        align: "center",
        children: children
      })]
    });
  };
  const renderModalContent = () => {
    if (error) {
      return renderSimpleModalWrapper( /*#__PURE__*/_jsx(ErrorComponent, {
        error: error
      }));
    } else if (progressTransferVerified) {
      trackEvent({
        action: 'certswap-verified'
      });
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          justifyContent: "center",
          children: /*#__PURE__*/_jsx(DialogHeaderImage, {
            offsetBottom: -20,
            offsetTop: 75,
            children: /*#__PURE__*/_jsx(Illustration, {
              height: 150,
              name: "success-green",
              width: 150
            })
          })
        }), /*#__PURE__*/_jsx(DialogBody, {
          children: /*#__PURE__*/_jsx(H1, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.transferVerifiedModal.title"
            })
          })
        }), /*#__PURE__*/_jsxs(DialogFooter, {
          align: "center",
          children: [/*#__PURE__*/_jsx(View, {
            as: "div",
            marginBlockEnd: "300",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "learningCenter.myTeam.transferVerifiedModal.warningPaidtoFreeTransition"
            })
          }), /*#__PURE__*/_jsx(Button, {
            onClick: onConfirm,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.transferVerifiedModal.confirmButton"
            })
          })]
        })]
      });
    }
    return renderSimpleModalWrapper( /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 300
    }));
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "progress-transfer-verified-modal",
    size: "auto",
    use: "info",
    width: 540,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onConfirm
      })
    }), renderModalContent()]
  });
};
export default ProgressTransferVerifiedModal;